export enum UrlParam {
  OrganizationId = 'organisation-id',
  IsChallenge = 'is-challenge',
  TimestampId = 'timestampId',
  Token = 'token',
  ChangeFor = 'change-for',
  Elementor = 'elementor',
  ElementorPreview = 'elementor-preview',
  ElementorPreviewId = 'preview_id',
  PageNumber = 'pageNumber',
  FilterTokenId = 'organizationId',
  TenantSection = 'tenantSection',
  Code = 'code',
  ResendEmail = 'resend-email',
  PreviousAction = 'previous-action',
  RegisterEvent = 'register-event',
  Error = 'error',
  RequiredLogin = 'required-login',
  Email = 'email',
  Register = 'register',
  SessionId = 'ssid',
  LeadOrgId = 'lead-org-id',
  OrgIds = 'OrgIds',
  IsIncludeMyself = 'isIncludeMyself',
  Action = 'action',
  TabNews = 'tabNews',
  MessageId = 'message-id',
  AssignToOrg = 'assign-to-org-id',
  AutoAssignment = 'auto-assignment',
  GlobalSearchTab = 'global-search-tab',
  SubOrganizationId = 'sub-organization',
  NotFound = 'notFound',
  NoAccess = 'noAccess',
  PaymentId = 'payment_id',
  PaymentEntityId = 'entity_id',
  EventDateTime = 'event-date-time',
  PopUpBlocked = 'popup-blocked',
  PostDetails = 'post-details',
  EventMode = 'mode',
  EventParticipantId = 'personId',
  QuickOrgUrl = 'quickOrgUrl',
  Section = 'section',
  GroupId = 'group-id',
  UtmSource = 'utm_source',
  RememberMe = 'remember-me',
}
